/**
 * Configured Axios instance with credentials enabled
 * Use this instead of importing axios directly
 */
import axios from "axios";

// Create a configured axios instance
const api = axios.create({
  withCredentials: true,
});

// Also set defaults for any direct axios imports
axios.defaults.withCredentials = true;

export default api;
export { api };
